// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IPageDto } from './page-dto.g';
import { IPageComponentDto } from './page-component-dto.g';
import { IClaimActionDto } from './claim-action-dto.g';
import { IPageComponentRefDto } from './page-component-ref-dto.g';
import { IClaimActionRefDto } from './claim-action-ref-dto.g';

export const claimRefDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    deleted: 'deleted',
    inactive: 'inactive',
    pageDto: 'pageDto',
    pageComponentDto: 'pageComponentDto',
    claimActionDto: 'claimActionDto',
} as const;

export type TClaimRefDto = (typeof claimRefDto)[keyof typeof claimRefDto];

export interface IClaimRefDto {
    [claimRefDto.guid]: string | null;
    [claimRefDto.nr]: number | null;
    [claimRefDto.name]: string | null;
    [claimRefDto.deleted]: boolean | null;
    [claimRefDto.inactive]: boolean | null;
    [claimRefDto.pageDto]: IPageDto | null;
    [claimRefDto.pageComponentDto]: IPageComponentRefDto | null;
    [claimRefDto.claimActionDto]: IClaimActionRefDto | null;
}

export class ClaimRefDto
    implements IClaimRefDto
{
    [claimRefDto.guid]: string | null = null;
    [claimRefDto.nr]: number | null = null;
    [claimRefDto.name]: string | null = null;
    [claimRefDto.deleted]: boolean | null = null;
    [claimRefDto.inactive]: boolean | null = null;
    [claimRefDto.pageDto]: IPageDto | null = null;
    [claimRefDto.pageComponentDto]: IPageComponentRefDto | null = null;
    [claimRefDto.claimActionDto]: IClaimActionRefDto | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IClaimRefData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[claimRefDto.guid] = modelData[claimrefData.guid];
    }

    static create(modelData?: any | null): IClaimRefDto | null {
        return modelData ? new ClaimRefDto(modelData) : null;
    }
}
